import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
} from '../../../dto/data-model.js';
import { OnlineProductOrder } from '../../online-product-order.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class OnlineProductOrderAbortedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '32ed5cb6006d43f08ca62bcda385db51';

  private constructor(
    public readonly before: OnlineProductOrder,
    public readonly after: OnlineProductOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OnlineProductOrderAbortedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OnlineProductOrderAborted;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      orderId: this.after.uniqueId,
      customerId: this.after.creatorId,
      isGuestOrder: this.after.isGuestOrder,
    };
  }

  static create(args: {
    before: OnlineProductOrder,
    after: OnlineProductOrder,
  }): OnlineProductOrderAbortedEntry {
    return new OnlineProductOrderAbortedEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OnlineProductOrderAbortedEntry {
    return this.create({
      before: context.fromData<OnlineProductOrder>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<OnlineProductOrder>(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return OnlineProductOrderAbortedEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
           isSameData(other.after, this.after);
  }
}

export class OnlineProductOrderAbortedEntryBuilder extends DataModelBuilder<OnlineProductOrderAbortedEntry> {
  build(context: SerializationContext, map: SerializedData): OnlineProductOrderAbortedEntry {
    return OnlineProductOrderAbortedEntry.fromMap(context, map);
  }
}
